const Form041TC = {
    stepName: {
        ImportantNotes: "重要事項",
        RegistrationAs: "註冊類型",
        PersonalParticulars: "個人資料",
        ChildCareTraining: "幼兒工作訓練",
        ChildCareExperience: "幼兒工作經驗",
        Annex: "附件",
        Confirmation: "確認",
    },
    ChildrenAgeOption: {},
    FirstAidTrainingOption: {},
    dateOfResignationOptions: {
        yes: "是",
        no: "否",
    },
    toolTip: {
        course: "#只提供課程的英文名稱。",
    },
    importantNotes: {
        p_title: "個人資料收集聲明",

        p_title_one: "<u>收集個人資料的目的</u>",
        p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        p1_a: "就幼兒中心職員註冊申請，辦理有關處理、核實及查證的事務；",
        p1_b: "就上文(a)項所述的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
        p1_c: "為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
        p1_d: "辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        p1_e: "辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
        p1_f: "辦理有關編製統計資料、研究材料及政府刊物的事務；以及",
        p1_g: "辦理有關施行及強制執行規則及規例 [包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 [即《幼兒服務規例》(香港法例第243A章)]的事務",
        p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",

        p_title_two: "<u>可獲轉移資料者</u>",
        p3: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        p3_a: "政府其他政策局及部門，包括社會福利署，以用於上文第1段所述的用途；",
        p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
        p3_c: "你曾就披露個人資料給予訂明同意；以及",
        p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        p_title_three: "<u>查閱個人資料</u>",
        p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 ",
    },
    notes: {
        title: "<u>重要事項</u>",
        bracket: "）",
        url: "https://www.edb.gov.hk/tc/edu-system/preprimary-kindergarten/application-for-registration-as-child-care-worker-supervisor/index.html",
        pographyOne:
            "根據《幼兒服務規例》第3(1)(a)或/及 (b)條，申請人須成功完成經社會福利署署長認可的訓練課程，方才符合註冊資格。有關符合註冊幼兒工作員和幼兒中心主管的認可課程，請參考教育局網頁（",
        pographyTwo:
            "沒有「智方便+」戶口的申請人須把已填妥的申請表列印並寄回或親身提交至香港太古城太古灣道14號6樓602室教育局幼稚園及幼兒中心聯合辦事處(本辦事處)辦理，並附上下列文件：",
        pographyTwo_a: "a) 身份證或護照副本；",
        pographyTwo_b: "b) 一式三張背後寫上申請人姓名的證件照片；及",
        pographyTwo_c:
            "c) 申請人的幼兒工作訓練證書和/或其他幼兒工作訓練證明文件副本。",
        pographyThree:
            "請確保已為郵件支付足夠郵資。郵資不足的郵件，一律將由香港郵政處理。",
        pographyFour: "請勿將遞交的文件釘在一起。",
        pographyFive:
            "申請人一般須親身到本辦事處與負責人員會面，並提供上述第(1)項所提及文件的正本，以供核實提交的副本，而使用電子表格的申請人須同時於會面時提交一式三張的證件照片。",
        pographySix:
            "申請人的姓名、註冊號碼、註冊日期將根據《幼兒服務規例 》第3條給公眾人士查閱，以證實申請人具備上述法例規定的註冊資格。",
        pographySeven: "如有查詢，請致電本辦事處，電話：3107 2197 或電郵至 ",
        pographySeven_url: "jokc@edb.gov.hk",
        termsConditions: "本人已閱讀、明白及同意上述條款及細則。",
        statement: "聲明",
        typeHeader: "申請註冊為",
        personalData: "<u>提供/處理個人資料</u>",
        personalParticulars: "個人資料",
        childCareTraining: "幼兒工作訓練",
        childCareExperience: "幼兒工作經驗（無須填寫課程實習訓練）",
        idAnnex: "身份證或護照副本",
        photograph: "申請人的證件照片",
        training: "申請人的幼兒工作訓練證書和／或其他幼兒工作訓練證明文件副本",
        dot: "。",
        registeringCCSCCWSameTime:
            "如你已修讀此課程，你可考慮同時申請註冊成為幼兒工作員及幼兒中心主管。",
    },
    otherNotes: {
        pographyOne:
            "申請人所提供的個人資料，會供本辦事處作註冊用途，<u>包括但不限於監察及檢討註冊程序、進行研究及調查，以及履行法定職責</u>。向本辦事處提供個人資料，純屬自願。如申請人未能提供足夠的個人資料，本辦事處可能無法處理其申請。",
        pographyTwo:
            "申請人所提供的個人資料可因應上文第(1)項所提及的用途，或在申請人同意下，或在法例授權或規定須予披露的情況下，向政府各決策局/部門披露。",
        pographyThree:
            "申請人請確保所提供的資料正確無誤。除了《個人資料〈私隱〉條例》規定的豁免範圍之外，申請人有權就本辦事處存有其個人資料提出查閱和改正要求。申請人亦可在繳付所需費用後，索取申請表內所填寫的個人資料複本。如欲查閱或改正申請表內所填寫的個人資料，請致電本辦事處，電話：3107 2197或電郵至 ",
        pographyThree_url: "jokc@edb.gov.hk",
    },
    label: {
        registrationType: "申請註冊為：",
        supervisor: "幼兒中心主管",
        childCareWorker: "幼兒工作員",
        title: "稱謂",
        // titleOption: {
        //     mr: "先生",
        //     mrs: "太太",
        //     miss: "小姐",
        //     ms: "女士",
        // },
        ccwSchoolOption: {
            1: "SWD, Training Section 社會福利署訓練組",
            2: "Hong Kong Polytechnic University 香港理工大學",
            3: "The Hong Kong Institute of Vocational Education (Lee Wai Lee) 香港專業教育學院李惠利分校",
            4: "The Hong Kong Institute of Vocational Education (Sha Tin) 香港專業教育學院沙田分校",
            5: "Hong Kong Baptist University, School of Continuing Education 香港浸會大學持續教育學院",
            6: "Hong Kong Institute of Education 香港教育學院 ／ The Education University of Hong Kong 香港教育大學",
            7: "The University of Hong Kong 香港大學",
            8: "The Open University of Hong Kong 香港公開大學",
            9: "Li Ka Shing Institute of Professional and Continuing Education / Li Ka Shing School of Professional and Continuing Education 香港公開大學李嘉誠專業進修學院",
            10: "Yew Chung Community College 耀中社區書院",
            11: "Yew Chung College of Early Childhood Education 耀中幼教學院",
            12: "Caritas Institute of Community Education 明愛社區書院",
            13: "Caritas Institute of Higher Education 明愛專上學院",
            14: "The Chinese University of Hong Kong 香港中文大學",
            15: "The School of Continuing and Professional Studies of the Chinese University of Hong Kong 香港中文大學專業進修學院",
            16: "Tung Wah College 東華學院",
            17: "Lingnan Institute of Further Education 嶺南大學持續進修學院",
            18: "Gratia Christian College 宏恩基督教學院",
            19: "Hong Kong College of Technology (HKCT) Institute of Higher Education 港專學院",
        },
        ccsSchoolOption: {
            5: "Hong Kong Baptist University, School of Continuing Education 香港浸會大學持續教育學院",
            6: "Hong Kong Institute of Education 香港教育學院 / The Education University of Hong Kong 香港教育大學",
            2: "Hong Kong Polytechnic University 香港理工大學",
            3: "The Hong Kong Institute of Vocational Education (Lee Wai Lee) 香港專業教育學院李惠利分校",
            4: "The Hong Kong Institute of Vocational Education (Sha Tin) 香港專業教育學院沙田分校",
            7: "The University of Hong Kong 香港大學",
            8: "The Open University of Hong Kong 香港公開大學",
            9: "Li Ka Shing Institute of Professional and Continuing Education /Li Ka Shing School of Professional and Continuing Education The Open University of Hong Kong香港公開大學李嘉誠專業進修學院",
            14: "The Chinese University of Hong Kong 香港中文大學",
            15: "The School of Continuing and Professional Studies of the Chinese University of Hong Kong 香港中文大學專業進修學院",
            10: "Yew Chung Community College 耀中社區書院",
            11: "Yew Chung College of Early Childhood Education 耀中幼教學院",
            12: "Caritas Institute of Community Education 明愛社區書院",
            13: "Caritas Institute of Higher Education 明愛專上學院",
            16: "Tung Wah College 東華學院",
            17: "Lingnan Institute of Further Education 嶺南大學持續進修學院",
            18: "Gratia Christian College 宏恩基督教學院",
            19: "Hong Kong College of Technology (HKCT) Institute of Higher Education 港專學院",
        },
        ccwCourseOption: {
            1: {
                1: "In-service Training Course for Nursery Workers#[Since13.8.1979]",
                2: "In-service Training Course for Crèche Workers#[Since13.8.1979]",
                3: "In-service Training Course for Playgroup Leaders#[Since13.8.1979]",
                4: "Pre-school Education Course Service Children Education Authority,Teachers’Centre, British Forces, HK#[Since13.8.1979]",
                5: "Hong Kong Nursery Workers’ Training Course, joint project of SWD &YWCA#[Since13.8.1979]",
                6: "Elementary Child Care Course#Since6.11.1979]",
            },
            2: {
                1: "Certificate in Child Care (1 year full time)#[Since13.8.1979]",
                2: "Part-time Day Release Certificate Course in Child Care (2 year part-time)#[Since13.8.1979]",
                3: "In-service Training Course for Nursery Workers#[Since5.5.1988]",
                4: "Basic Course for Child Care Workers#[Since5.5.1988]",
                5: "Basic Course for English-speaking Child Care Workers#[Since5.5.1988]",
                6: [
                    "The Certificate Course in Pre-primary Education (Distance Learning Mode)[Since 10.7.1989]",
                    "學前教育證書課程(遙距課程)[自10.7.1989開始]",
                ],
                7: [
                    "Certificate Course in Pre-primary Education for 2000/2001 (1 year pre-service full-time)[Since operation]",
                    "2000/2001學前教育證書課程(一年全日制職前課程)[自開辦始]",
                ],
                8: [
                    "Bachelor of Arts (Honours) in Pre-primary Education [Students who have successfully completed Stage 1 and 2 of the Bachelor of Arts (Honours) in Pre-primary Education may apply for individual recognition of Child Care worker equivalent qualification.][Since 18.2.2002]",
                    "學前教育(榮 譽)文學士學位課程[已成功完成學前教育(榮譽)文學士學位課程第一及第二階段課程之學員，可申請獨立認可其幼兒工作員等同資歷][自18.2.2002開始]",
                ],
            },
            3: {
                1: "Certificate Course in Child Care#[Since6.2.1981]",
                2: "Certificate in Care of Pre-school Children (2 year full-time)#[Since5.5.1988]",
                3: [
                    "Certificate in Child Care (1 year full time pre-service mode)[Since 5.5.1988]",
                    "幼兒工作證書(一年全日職前訓練制)[自5.5.1988開始]",
                ],
                4: [
                    "Certificate in Child Care (2 year part-time day release in-service mode)[Since 5.5.1988]",
                    "幼兒工作證書(兩年日間部份時間給假調訓在職訓練制)[自5.5.1988開始]",
                ],
                5: [
                    "Vocational Certificate in Basic Child Care Work (1 year part-time day release in-service mode)The course was named as Certificate in Basic Child Care Work (1 year part-time day release in-service mode) prior to 1999-2000.[Since 3.3.1995]",
                    "基本幼兒工作職業技術證書(一年日間部份時間給假調訓在職訓練制)此課程於1999/2000前稱為基本幼兒工作證書[自3.3.1995 開始]",
                ],
                6: "Basic Course for English-speaking Child Care Workers#[Since3.3.1995]",
                7: [
                    "Diploma in Child Care and Education (pre-service 2 year full time)[Since 27.11.2001]",
                    "幼兒教育文憑(兩年全日職前訓練制)[自27.11.2001開始]",
                ],
                8: [
                    "Higher Diploma in Child Care and Education (pre-service 3 year full time)[Students who have successfully completed Year One of Higher Diploma in Child Care & Education may apply for individual assessment of Child Care Worker equivalent qualification.][Since 27.11.2001]",
                    "幼兒教育高級文憑(三年全日職前訓練 制)[已成功完成幼兒教育高級文憑(三年全日職前訓練制)第一年課程之學員，可申請獨立評估其幼兒工作員等同資歷。][自27.11.2001 開始]",
                ],
                9: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Graduatesfrom July 2009 onwards]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自2009年7月或以後畢業生開始]",
                ],
            },
            4: {
                1: [
                    "Higher Diploma in Child Care and Education (pre-service 3 year full time)[Since operation]",
                    "幼兒教育高級文憑(三年全日職前訓練制)[自開辦始]",
                ],
                2: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Since operation]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自開辦始]",
                ],
                3: [
                    "Higher Diploma in Child Care and Education (3-year part time evening) [Graduates from 2008 to 2012 could be registered with satisfactory completion of the Certificate in Basic Child Care Work (Bridging Course) organised by The Hong Kong Institute of Vocational Education (Sha Tin).]",
                    "幼兒教育高級文憑 (三年晚間兼讀制)[2008至2012年期間的畢業生，可透過成功完成香港專業教育學院沙田分校舉辦的「基本幼兒工作証書(銜接課程)」，以達到註冊要求][2013年或以後畢業]",
                ],
                4: [
                    "Higher Diploma in Special Child Care and Inclusive Education[Graduate from 2019 to 2022]",
                    "特殊幼兒照顧及融合教育高級文憑[2019至2022年畢業]",
                ],
            },
            5: {
                1: [
                    "Certificate Course in Early Childhood Education [Graduates before 4.6.1997 could be registered with completion of the Conversion Programme in Early Childhood Education organized by HKBU.][Since 4.6.1997]",
                    "幼兒教育證書課程[4.6.1997前的畢業生可透過完成香港浸會大學舉辦的幼兒教育銜接課程以達到註冊要求][自4.6.1997 開始]",
                ],
                2: [
                    "One-year Pre-service Basic Early childhood Education Course for 2001-02[Since operation]",
                    "2001/2002一年全日制職前幼兒教師培訓課程[自開辦始]",
                ],
                3: [
                    "Higher Diploma in Early Childhood Education[Since September 2007]",
                    "幼兒教育高級文憑課程[自2007年9月開始]",
                ],
                4: [
                    "Postgraduate Diploma in Early Childhood Education[Since June 2009]",
                    "幼兒教育深造文憑課程[自2009年6月開始]",
                ],
                5: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育學教育學士(榮譽)學位[自2012/13學年開始]",
                ],
            },
            6: {
                1: [
                    "Qualified Kindergarten Teacher Education Course (Chinese) (1 year day release or evening mixed mode)[Since 9.12.1997]",
                    "合格幼稚園教師在職訓練課程(中文)(一年日間/夜間混合制)[自9.12.1997開始]",
                ],
                2: [
                    "Qualified Kindergarten Teacher Education (Conversion) Course (Chinese) (1 year day release or evening mixed mode)[Since 9.12.1997]",
                    "合格幼稚園教師轉讀課程(中文)(一年日間/夜間混合制)[自9.12.1997開始]",
                ],
                3: [
                    "Qualified Kindergarten Teacher Education Course (English) (1 year day release mode)[Since 3.3.2001]",
                    "合格幼稚園教師在職訓練課程(英文)(一年日間部份時間給假制)[自3.3.2001開始]",
                ],
                4: [
                    "Qualified Kindergarten Teacher Education Course (Chinese) (2 year part-time evening)[Since 5.6.2001]",
                    "合格幼稚園教師在職訓練課程(中文)(二年夜間部份時間制)[自5.6.2001開始]",
                ],
                5: [
                    "Qualified Kindergarten Teacher Education Course (Conversion) (Chinese) (2 year part-time evening)[Since 5.6.2001]",
                    "合格幼稚園教師轉讀課程(中文)(二年夜間部份時間制)[自5.6.2001開始]",
                ],
                6: [
                    "Qualified Kindergarten Teacher Education Course (Chinese) (1 year full time)[Since 5.6.2001]",
                    "合格幼稚園教師訓練課程(中文)(一年全日制)[自5.6.2001開始]",
                ],
                7: [
                    "Certificate in Early Childhood Education (Chinese) Programme (3 year full time)[Renamed as Higher Diploma in Early Childhood Education Programme (2-year full-time) and (3-year full-time) from 2009/10 school year. First cohort of graduates is expected in 2011 & 2012.][Since 30.8.1999]",
                    "幼兒教育證書(中文)課程(三年全日制)[由2009/10學年開始，課程名稱改為幼兒教育高級文憑課程(二年全日制)及(三年全日制)。第一批學生預計於2011年及2012年畢業][自30.8.1999 開 始]",
                ],
                8: [
                    "Bachelor of Education (Honours) (Early Childhood Education)[Bed(ECE)](4 year full time)[Since 13.7.2005]",
                    "幼兒教育榮譽學士[Bed(ECE)](四年全日制)[自13.7.2005開始]",
                ],
                9: [
                    "Bachelor of Education (Honours) (Early Childhood Education)[Bed(ECE)](5 year full time)[Graduate from 2016/17 School Year onwards]",
                    "幼兒教育榮譽學士[Bed(ECE)](五年全日制)[2016/17學年或以後畢業]",
                ],
                10: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)](2 year part-time in-service)[Since 13.7.2005] ",
                    "學位教師教育文憑課程(幼兒教育)[PGDE(ECE)](二年部份時間制)[自13.7.2005開始]",
                ],
                11: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)] (2 year part-time)[Since 2015/16 School Year]",
                    "學位教師教育深造文憑(幼兒教育)(二年兼讀制)[自2015/16學年開始]",
                ],
                12: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)] (1 Year Full-time)[Graduate from 2017/18 School Year onwards]",
                    "學位教師教育深造文憑(幼兒教育)(一年全日制)[自2017/18學年或以後畢業]",
                ],
            },
            7: {
                1: "PGDE (Major in Early Childhood Education)#[Since9.2.2007]",
                2: [
                    "Bachelor of Science in Applied Child Development[Since operation]",
                    "理學士(應用兒童發展)[自開辦始]",
                ],
                3: [
                    "Bachelor of Education in Early Childhood Education and Special Education (5-year Full-time)[Graduate from 2024 onwards]",
                    "教育學士(幼兒教育及特殊教育)(五年全日制)[2024年或以後畢業]",
                ],
            },
            8: {
                1: "Diploma in Early Childhood Education#[Since 28.2.2007]",
                2: [
                    "Bachelor of Education with Honours in Early Childhood Education (Leadership and Special Educational Needs)[Graduate from 2022 onwards]",
                    "教育榮譽學士(幼兒教育：領導及特殊教育需要)[2022年或以後畢業]",
                ],
            },
            9: {
                1: "Diploma in Enlightened Early Childhood Education#[Since31.3.2008]",
                2: [
                    "Higher Diploma in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育高級文憑[自2012/13學年開始]",
                ],
            },
            10: {
                1: [
                    "Higher Diploma in Early Childhood Education [Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2016 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2016至2024年畢業]",
                ],
            },
            11: {
                1: [
                    "Higher Diploma in Early Childhood Education [Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2019至2024年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education [BEd(ECE)][Graduate from 2022 to 2026]",
                    "幼兒教育(榮譽)學士[2022至2026年畢業]",
                ],
            },
            12: {
                1: [
                    "Higher Diploma in Early Childhood Education[Full-time students will graduate from 2017 to 2022 , Part-time students will graduate in 2019 and 2020]",
                    "幼兒教育高級文憑[全日制學生於2017至2022年畢業,兼讀制學生於2019及2020年畢業]",
                ],
            },
            13: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2023]",
                    "幼兒教育高級文憑[2019至2023年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2024 to 2027]",
                    "幼兒教育榮譽學士[2024至2027年畢業]",
                ],
            },
            14: {
                1: "Postgraduate Diploma in Education (Early Childhood Education)[Graduate from 2016/17 School Year onwards][2016/17學年或以後畢業]",
                2: [
                    "Bachelor of Education Programme in Early Childhood Education [Graduate from 2024 onwards]",
                    "幼兒教育教育學士課程[2024年或以後畢業]",
                ],
            },
            15: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2020]",
                    "幼兒教育高級文憑[自2020年畢業]",
                ],
            },
            16: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2018 to 2023]",
                    "幼兒教育高級文憑[2018至2023年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2019 to 2022]",
                    "幼兒教育(榮譽)學士學位[2019至2022年畢業]",
                ],
            },
            17: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2019]",
                    "幼兒教育高級文憑[自2019年畢業]",
                ],
            },
            18: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[2019至2024年畢業]",
                ],
            },
            19: {
                1: [
                    "Graduate from 2020 to 2026",
                    "幼兒教育高級文憑(融合教育)[2020至2026年畢業]",
                ],
            },
        },
        ccsCourseOption: {
            5: {
                6: [
                    "Advanced Diploma in Early Childhood Education Course[Course was renamed as Higher Diploma in Early Childhood Education Course w.e.f. September 2007.][Since30.6.2001]",
                    "幼兒教育高級文憑[由2007年9月起課程名稱改為幼兒教育高級文憑課程][自30.6.2001開始]",
                ],
                3: [
                    "Higher Diploma in Early Childhood Education[Since September 2007]",
                    "幼兒教育高級文憑課程[自2007年9月開始]",
                ],
                8: [
                    "Postgraduate Diploma in Early Childhood Education[Since June 2009]",
                    "幼兒教育深造文憑課程[自2009年6月開始]",
                ],
                5: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育學教育學士(榮譽)學位[自2012/13學年開始]",
                ],
            },
            6: {
                13: [
                    "Certificate in Kindergarten Education (Chinese Programme) (2 year day release or evening mixed mode)[Renamed as Higher Diploma in Kindergarten Education Programme (2-year day release mixed mode) and (2-year evening mixed mode) from 2009/10 school year. First cohort of graduates is expected in 2011.][Since operation]",
                    "幼稚園教育證書(中文)課程(二年日間/夜間混合制)[由2009/10學年開始，課程名稱改為幼稚園教育高級文憑(二年日間部份時間給假調訓混合制)及(二年夜間混合制)。第一批學生預期於2011年畢業][自開辦始]",
                ],
                14: [
                    "Certificate in Kindergarten Education (Chinese Programme) (3 year part-time evening)[Since operation]",
                    "幼稚園教育證書(中文)課程(三年夜間部份時間制)[自開辦始]",
                ],
                7: [
                    "Certificate in Early Childhood Education (Chinese) Programme (3 year full time)[Renamed as Higher Diploma in Early Childhood Education Programme (2-year full-time) and (3-year full-time) from 2009/10 school year. First cohort of graduates is expected in 2011 & 2012.][Since operation]",
                    "幼兒教育證書(中文)課程(三年全日制)[由2009/10學年開始，課程名稱改為幼兒教育高級文憑課程(二年全日制)及(三年全日制)。第一批學生預計於2011年及2012年畢業]",
                ],
                8: [
                    "Bachelor of Education (Honours) (Early Childhood Education) [Bed(ECE)] (4 year full time)[Since 13.7.2005]",
                    "幼兒教育榮譽學士(四年全日制)[自13.7.2005開始]",
                ],
                9: [
                    "Bachelor of Education (Honours) (Early Childhood Education) [Bed(ECE)] (5 year full time)[Graduate from 2016/17 School Year onwards]",
                    "幼兒教育榮譽學士(五年全日制)[自2016/17學年或以後畢業]",
                ],
                18: [
                    "Master of Education (ECE Specialization)#[2005-07EntryOnly]",
                    "[Graduates are required to be qualified kindergarten teacher or child care worker and have satisfactorily completed additional modules in the areas of “Children with Diverse Needs”, “Parental Involvement in Early Childhood Education” and “Educational and Administrative Management in early Childhood settings”at the certificate level or above.]",
                ],
                19: [
                    "Postgraduate Diploma in Education (Early Childhood Education) [PGDE(ECE)] (2 year part-time in-service)[Since June 2007]",
                    "學位教師教育文憑(幼兒教育)[PGDE(ECE)](二年在職部份時間制)[自2007年6月開始]",
                ],
                10: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)](2 year part-time)[Since 2015/16 School Year]",
                    "學位教師教育深造文憑(幼兒教育)(二年兼讀制)[自2015/16學年開始]",
                ],
                11: [
                    "Postgraduate Diploma in Education (Early Childhood Education) [PGDE(ECE)] (1 Year Full-time)",
                    "學位教師教育深造文憑(幼兒教育)(一年全日制)[自2017/18學年或以後畢業]",
                ],
            },
            2: {
                9: [
                    "Higher Diploma in Pre-primary Education [Graduates of the Higher Diploma in Pre-primary Education who graduated before 31.5.2001 could apply for qualification recognition and they will be assessed on individual basis.][Since 31.5.2001]",
                    "學前教育高級文憑[於31.5.2001前修畢學前教育高級文憑之學員，可申請學歷認可，並將根據個別情況審批其學歷][自31.5.2001開始]",
                ],
                8: [
                    "Bachelor of Arts (Honours) in Pre-primary Education[Since 18.2.2002]",
                    "學前教育(榮譽)文學士學位課程[自18.2.2002開始]",
                ],
            },
            3: {
                8: [
                    "Higher Diploma in Child Care and Education (pre-service) (3 year full time)[Since 27.11.2001]",
                    "幼兒教育高級文憑(三年全日職前訓練制)[自27.11.2001開始]",
                ],
                11: [
                    "Higher Diploma in Child Care and Education (part-time module accumulation course)[Since 27.11.2001]",
                    "幼兒教育高級文憑(部份時間單元儲修制)[自27.11.2001開始]",
                ],
                12: [
                    "Two-year In-service Certificate in Early Childhood Education Course(Higher Diploma in Child Care and education)[Since operation]",
                    "二年制在職幼兒教育證書課程(幼兒教育高級文憑)[自開辦始]",
                ],
                13: "Higher Diploma in Child Education and Management#(one year full time top-up programme with two year full time Diploma Programme in Child Care and Education)[Sinceoperation]",
                9: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Graduates from July 2009 onwards]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自2009年7月或以後畢業生開始]",
                ],
            },
            4: {
                1: [
                    "Higher Diploma in Child Care and Education (pre-service 3 year full time)[Since operation]",
                    "幼兒教育高級文憑(三年全日職前訓練制)[自開辦始]",
                ],
                5: [
                    "Higher Diploma in Child Care and Education (part-time module accumulation course)[Since operation]",
                    "幼兒教育高級文憑(部份時間單元儲修制)[自開辦始]",
                ],
                2: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Since operation]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自開辦始]",
                ],
                3: [
                    "Higher Diploma in Child Care and Education (3-year part time evening)[Graduates from 2008 to 2012 could be registered with satisfactory completion of the Certificate in Basic Child Care Work (Bridging Course) organised by The Hong Kong Institute of Vocational Education (Sha Tin).][Graduate from 2013 onwards]",
                    "幼兒教育高級文憑（三年晚間兼讀制）[2008至2012年期間的畢業生，可透過成功完成香港專業教育學院沙田分校舉辦的「基本幼兒工作証書(銜接課程)」，以達到註冊要求]",
                ],
                4: [
                    "Higher Diploma in Special Child Care and Inclusive Education[Graduate from 2019 to 2022]",
                    "特殊幼兒照顧及融合教育高級文憑[2019至2022年畢業]",
                ],
            },
            7: {
                1: "PGDE (Major in Early Childhood Education)#[Since9.2.2007]",
                2: [
                    "Bachelor of Science in Applied Child Development[Since operation]",
                    "理學士(應用兒童發展)[自開辦始]",
                ],
                3: [
                    "Bachelor of Education in Early Childhood Education and Special Education (5-year Full-time)[Graduate from 2024 onwards]",
                    "教育學士(幼兒教育及特殊教育)(五年全日制)[2024年或以後畢業]",
                ],
            },
            8: {
                1: "Diploma in Early Childhood Education#[Since 28.2.2007]",
                2: [
                    "Bachelor of Education with Honours in Early Childhood Education (Leadership and Special Educational Needs)[Graduate from 2022 onwards]",
                    "教育榮譽學士(幼兒教育：領導及特殊教育需要)[2022年或以後畢業]",
                ],
            },
            9: {
                1: "Diploma in Enlightened Early Childhood Education#[Since31.3.2008]",
                2: [
                    "Higher Diploma in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育高級文憑[自2012/13學年開始]",
                ],
            },
            14: {
                3: "Certificate in Early Childhood Education#[Since11.9.2006]",
                1: "Postgraduate Diploma in Education (Early Childhood Education)[Graduate from 2016/17 School Year onwards]",
                2: [
                    "Bachelor of Education Programme in Early Childhood Education[Graduate from 2024 onwards]",
                    "幼兒教育教育學士課程[2024年或以後畢業]",
                ],
            },
            15: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2020]",
                    "幼兒教育高級文憑[自2020年畢業]",
                ],
            },
            10: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2016 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2016 至 2024 年畢業]",
                ],
            },
            11: {
                1: [
                    "Higher Diploma in Early Childhood Education [Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2019 至 2024 年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education [BEd(ECE)][Graduate from 2022 to 2026]",
                    "幼兒教育(榮譽)學士[2022至2026年畢業]",
                ],
            },
            12: {
                1: [
                    "Higher Diploma in Early Childhood Education[Full-time students will graduate from 2017 to 2022 Part-time students will graduate in 2019 and 2020]",
                    "幼兒教育高級文憑[全日制學生於2017至2022年畢業,兼讀制學生於2019及2020年畢業]",
                ],
            },
            13: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2023]",
                    "幼兒教育高級文憑[2019至2025年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2024 to 2027]",
                    "幼兒教育榮譽學士[2024至2027年畢業]",
                ],
            },
            16: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2018 to 2023]",
                    "幼兒教育高級文憑[2018至2023年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2019 to 2022]",
                    "幼兒教育(榮譽)學士學位[2019至2022年畢業]",
                ],
            },
            17: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2019]",
                    "幼兒教育高級文憑[自2019年畢業]",
                ],
            },
            18: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[2019至2024年畢業]",
                ],
            },
            19: {
                1: [
                    "Higher Diploma in Early Childhood Education (Inclusive Education)[HDECE(IE)][Graduate from 2020 to 2026]",
                    "幼兒教育高級文憑(融合教育)[2020至2026年畢業]",
                ],
            },
        },
        // ccwSchoolOption: {
        //     1: "社會福利署訓練組",
        //     2: "香港理工大學",
        //     3: "香港專業教育學院李惠利分校",
        //     4: "香港專業教育學院沙田分校",
        //     5: "香港浸會大學持續教育學院",
        //     6: "香港教育學院 ／ 香港教育大學",
        //     7: "香港大學",
        //     8: "香港公開大學 / 香港都會大學",
        //     9: "香港公開大學李嘉誠專業進修學院 / 香港都會大學李嘉誠專業進修學院",
        //     10: "耀中社區書院",
        //     11: "耀中幼教學院",
        //     12: "明愛社區書院",
        //     13: "明愛專上學院",
        //     14: "香港中文大學",
        //     15: "香港中文大學專業進修學院",
        //     16: "東華學院",
        //     17: "嶺南大學持續進修學院",
        //     18: "宏恩基督教學院",
        //     19: "港專學院",
        // },
        // ccsSchoolOption: {
        //     5: "香港浸會大學持續教育學院",
        //     6: "香港教育學院 / 香港教育大學",
        //     2: "香港理工大學",
        //     3: "香港專業教育學院李惠利分校",
        //     4: "香港專業教育學院沙田分校",
        //     7: "香港大學",
        //     8: "香港公開大學 / 香港都會大學",
        //     9: "香港公開大學李嘉誠專業進修學院 / 香港都會大學李嘉誠專業進修學院",
        //     14: "香港中文大學",
        //     15: "香港中文大學專業進修學院",
        //     10: "耀中社區書院",
        //     11: "耀中幼教學院",
        //     12: "明愛社區書院",
        //     13: "明愛專上學院",
        //     16: "東華學院",
        //     17: "嶺南大學持續進修學院",
        //     18: "宏恩基督教學院",
        //     19: "港專學院",
        // },

        // ccwCourseOption: {
        //     1: {
        //         1: "In-service Training Course for Nursery Workers*  [Since 13.8.1979]",
        //         2: "In-service Training Course for Crèche Workers*  [Since 13.8.1979]",
        //         3: "In-service Training Course for Playgroup Leaders*  [Since 13.8.1979]",
        //         4: "Pre-school Education Course Service Children Education Authority, Teachers' Centre, British Forces, HK*  [Since 13.8.1979]",
        //         5: "Hong Kong Nursery Workers' Training Course, joint project of SWD &YWCA*  [Since 13.8.1979]",
        //         6: "Elementary Child Care Course*  [Since 6.11.1979]",
        //     },
        //     2: {
        //         1: "Certificate in Child Care (1 year full time)*  [Since 13.8.1979]",
        //         2: "Part-time Day Release Certificate Course in Child Care (2 year part-time)*  [Since 13.8.1979]",
        //         3: "In-service Training Course for Nursery Workers*  [Since 5.5.1988]",
        //         4: "Basic Course for Child Care Workers*  [Since 5.5.1988]",
        //         5: "Basic Course for English-speaking Child Care Workers*  [Since 5.5.1988]",
        //         6: "學前教育證書課程(遙距課程)  [自 10.7.1989開始]",
        //         7: "2000/2001學前教育證書課程 (一年全日制職前課程)  [自開辦始]",
        //         8: [
        //             "學前教育(榮譽)文學士學位課程  [自 18.2.2002開始]",
        //             "[已成功完成學前教育 (榮譽)文學士學位課程第一及第二階段課程之學員，可申請獨立認可其幼兒工作員等同資歷]",
        //         ],
        //     },
        //     3: {
        //         1: "Certificate Course in Child Care*  [Since 6.2.1981]",
        //         2: "Certificate in Care of Pre-school Children (2 year full-time)*  [Since 5.5.1988]",
        //         3: "幼兒工作證書 (一年全日職前訓練制)  [自 5.5.1988開始]",
        //         4: "幼兒工作證書 (兩年日間部份時間給假調訓在職訓練制)  [自 5.5.1988開始]",
        //         5: [
        //             "基本幼兒工作職業技術證書 (一年日間部份時間給假調訓在職訓練制)  [自 3.3.1995開始]",
        //             "此課程於1999/2000前稱為基本幼兒工作證書",
        //         ],
        //         6: "Basic Course for English-speaking Child Care Workers*  [Since 3.3.1995]",
        //         7: "幼兒教育文憑 (兩年全日職前訓練制)  [自 27.11.2001開始]",
        //         8: [
        //             "幼兒教育高級文憑 (三年全日職前訓練制)  [自 27.11.2001開始]",
        //             "[已成功完成幼 兒教育高級文憑 (三年全日職前訓練制)第一年課程之學員，可申請獨立評估其幼兒工作員等同資歷。]",
        //         ],
        //         9: "幼兒教育高級文憑 (兩年全日職前訓練制)  [自 2009年 7月或以後畢業生開始]",
        //     },
        //     4: {
        //         1: "幼兒教育高級文憑 (三年全日職前訓練制)  [自開辦始]",
        //         2: "幼兒教育高級文憑 (兩年全日職前訓練制)  [自開辦始]",
        //         3: [
        //             "幼兒教育高級文憑 (三年晚間兼讀制)  [2013年或以後畢業]",
        //             "[2008至2012年期間的畢業生，可透過成功完成香港專業教育學院沙田分校舉辦的「基本幼兒工作証書(銜接課程)」，以達到註冊要求]",
        //         ],
        //         4: "特殊幼兒照顧及融合教育高級文憑  [2019至2022年畢業]",
        //     },
        //     5: {
        //         1: [
        //             "幼兒教育證書課程  [自 4.6.1997開始]",
        //             "[4.6.1997前的畢業生可透過完成香港浸會大學舉辦的幼兒教育銜接課程以達到註冊要求]",
        //         ],
        //         2: "2001/2002 一年全日制職前幼兒教師培訓課程  [自開辦始]",
        //         3: "幼兒教育高級文憑課程  [自 2007年 9月開始]",
        //         4: "幼兒教育深造文憑課程  [自 2009年 6月開始]",
        //         5: "幼兒教育學教育學士(榮譽)學位  [自 2012/13 學年開始]",
        //     },
        //     6: {
        //         1: "合格幼稚園教師在職訓練課程 (中文) (一年日間/夜間混合制)  [自 9.12.1997開始]",
        //         2: "合格幼稚園教師轉讀課程 (中文) (一年日間/夜間混合制)  [自 9.12.1997開始]",
        //         3: "合格幼稚園教師在職訓練課程 (英文) (一年日間部份時間給假制)  [自 3.3.2001開始]",
        //         4: "合格幼稚園教師在職訓練課程 (中文) (二年夜間部份時間制)  [自 5.6.2001開始]",
        //         5: "合格幼稚園教師轉讀課程 (中文 ) (二年夜間部份時間制)  [自 5.6.2001開始]",
        //         6: "合格幼稚園教師訓練課程 (中文) (一年全日制)  [自 5.6.2001開始]",
        //         7: [
        //             "幼兒教育證書(中文)課程 (三年全日制)  [自 30.8.1999開始]",
        //             "[由 2009/10學年開始，課程名稱改為幼兒教育高級文憑課程(二年全日制)及(三年全日制)。第 一批學生預計於 2011 年及 2012年畢業]",
        //         ],
        //         8: "幼兒教育榮譽學士 [Bed(ECE)] (四年全日制)  [自 13.7.2005開始]",
        //         9: "幼兒教育榮譽學士 [Bed(ECE)] (五年全日制)  [2016/17學年或以後畢業]",
        //         10: "學位教師教育文憑課程 (幼兒教育)[PGDE(ECE)] (二年部份時間制)  [自 13.7.2005開始]",
        //         11: "學位教師教育深造文憑 (幼兒教育) (二年兼讀制)  [自 2015/16 學年開始]",
        //         12: "學位教師教育深造文憑 (幼兒教育) (一年全日制)  [自 2017/18 學年或以後畢業]",
        //     },
        //     7: {
        //         1: "PGDE (Major in Early Childhood Education)*  [Since 9.2.2007]",
        //         2: "理學士 (應用兒童發展)  [自開辦始]",
        //         3: "教育學士 (幼兒教育及特殊教育) (五年全日制)  [2024年或以後畢業]",
        //     },
        //     8: {
        //         1: "幼兒教育文憑  [自28.2.2007開始]",
        //         2: "教育榮譽學士 (幼兒教育：領導及特殊教育需要)  [2022年或以後畢業]",
        //     },
        //     9: {
        //         1: "Diploma in Enlightened Early Childhood Education*  [Since 31.3.2008]",
        //         2: "幼兒教育高級文憑  [自 2012/13學年開始]",
        //     },
        //     10: {
        //         1: [
        //             "幼兒教育高級文憑  [2016至2024年畢業]",
        //             "[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。]",
        //         ],
        //     },
        //     11: {
        //         1: [
        //             "幼兒教育高級文憑  [2019至2024年畢業]",
        //             "[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。]",
        //         ],
        //         2: "幼兒教育(榮譽)學士  [2022至2026年畢業]",
        //     },
        //     12: {
        //         1: "幼兒教育高級文憑  [全日制學生於2017至2022年畢業, 兼讀制學生於2019及2020年畢業]",
        //     },
        //     13: {
        //         1: "幼兒教育高級文憑  [2019至2025年畢業]",
        //         2: "幼兒教育榮譽學士  [2024至2027年畢業]",
        //     },
        //     14: {
        //         1: "[2016/17學年或以後畢業]",
        //         2: "幼兒教育教育學士課程  [2024年或以後畢業]",
        //     },
        //     15: {
        //         1: "幼兒教育高級文憑  [自 2020年畢業]",
        //     },
        //     16: {
        //         1: "幼兒教育高級文憑  [2018至2023年畢業]",
        //         2: "幼兒教育(榮譽)學士學位  [2019至2022年畢業]",
        //     },
        //     17: {
        //         1: "幼兒教育高級文憑  [自 2019年畢業]",
        //     },
        //     18: {
        //         1: "幼兒教育高級文憑  [2019至2024年畢業]",
        //     },
        //     19: {
        //         1: "幼兒教育高級文憑 (融合教育)  [2020至2026年畢業]",
        //     },
        // },
        // ccsCourseOption: {
        //     5: {
        //         6: [
        //             "幼兒教育高級文憑 (融合教育)  [2020至2026年畢業]",
        //             "[由 2007年 9月起課程名稱改為幼兒教育高級文憑課程]",
        //         ],
        //         3: "幼兒教育高級文憑  [自 30.6.2001開始]",
        //         8: "幼兒教育深造文憑課程  [自 2009年 6月開始]",
        //         5: "幼兒教育學教育學士(榮譽)學位  [自 2012/13學年開始]",
        //     },
        //     6: {
        //         13: [
        //             "幼稚園教育證書(中文)課程 (二年日間/夜間混合制)  [自開辦始]",
        //             "[由 2009/10學年開始，課程名稱改為幼稚園教育高級文憑(二年日間部份時間給假調訓混合制)及(二年夜間混合制)。第一批學生預期於 2011年畢業]",
        //         ],
        //         14: "幼稚園教育證書(中文)課程 (三年夜間部份時間制)  [自開辦始]",
        //         7: [
        //             "幼兒教育證書(中文)課程 (三年全日制)  [自開辦始]",
        //             "[由 2009/10學年開始，課程名稱改為幼兒教育高級文憑課程(二年全日制)及(三年全日制)。第一批學生預計於 2011年及 2012年畢業]",
        //         ],
        //         8: "幼兒教育榮譽學士 (四年全日制)  [自 13.7.2005開始]",
        //         9: "幼兒教育榮譽學士 (五年全日制)  [自 2016/17學年或以後畢業]",
        //         18: [
        //             "Master of Education (ECE Specialization)*  [2005-07 Entry Only]",
        //             "[Graduates are required to be qualified kindergarten teacher or child care worker and have satisfactorily completed additional modules in the areas of “Children with Diverse Needs”, “Parental Involvement in Early Childhood Education” and “Educational and Administrative Management in early Childhood settings”at the certificate level or above.]",
        //         ],
        //         19: "學位教師教育文憑(幼兒教育) [PGDE(ECE)] (二年在職部份時間制)  [自 2007年 6月開始]",
        //         10: "學位教師教育深造文憑 (幼兒教育) (二年兼讀制)   [自 2015/16 學年開始]",
        //         11: "學位教師教育深造文憑 (幼兒教育) (一年全日制)  [自 2017/18 學年或以後畢業]",
        //     },
        //     2: {
        //         9: [
        //             "學前教育高級文憑  [自 31.5.2001開始]",
        //             "[於 31.5.2001前修畢學前教育高級文憑之學員，可申請學歷認可，並將根據個別情況審批其學歷]",
        //         ],
        //         8: "學前教育(榮譽)文學士學位課程  [自 18.2.2002開始]",
        //     },
        //     3: {
        //         8: "幼兒教育高級文憑 (三年全日職前訓練制)  [自 27.11.2001開始]",
        //         11: "幼兒教育高級文憑 (部份時間單元儲修制)  [自 27.11.2001開始]",
        //         12: "二年制在職幼兒教育證書課程 (幼兒教育高級文憑)  [自開辦始]",
        //         13: "Higher Diploma in Child Education and Management*  [Since operation]",
        //         9: "幼兒教育高級文憑 (兩年全日職前訓練制)  [自 2009年 7月或以後畢業生開始]",
        //     },
        //     4: {
        //         1: "幼兒教育高級文憑 (三年全日職前訓練制)  [自開辦始]",
        //         5: "幼兒教育高級文憑 (部份時間單元儲修制)  [自開辦始]",
        //         2: "幼兒教育高級文憑 (兩年全日職前訓練制)  [自開辦始]",
        //         3: [
        //             "幼兒教育高級文憑 (三年晚間兼讀制)  [2013年或以後畢業]",
        //             "[2008至2012年期間的畢業生，可透過成功完成香港專業教育學院沙田分校舉辦的「基本幼兒工作証書(銜接課程)」，以達到註冊要求]",
        //         ],
        //         4: "特殊幼兒照顧及融合教育高級文憑  [2019至2022年畢業]",
        //     },
        //     7: {
        //         1: "PGDE (Major in Early Childhood Education)*  [Since 9.2.2007]",
        //         2: "理學士 (應用兒童發展)  [自開辦始]",
        //         3: "教育學士 (幼兒教育及特殊教育) (五年全日制)  [2024年或以後畢業]",
        //     },
        //     8: {
        //         1: "幼兒教育文憑  [自28.2.2007開始]",
        //         2: "教育榮譽學士 (幼兒教育：領導及特殊教育需要)  [2022年或以後畢業]",
        //     },
        //     9: {
        //         1: "Diploma in Enlightened Early Childhood Education*  [Since 31.3.2008]",
        //         2: "幼兒教育高級文憑  [自2012/13學年開始]",
        //     },
        //     14: {
        //         3: "Certificate in Early Childhood Education*  [Since 11.9.2006]",
        //         1: "[2016/17學年或以後畢業]",
        //         2: "幼兒教育教育學士課程  [2024年或以後畢業]",
        //     },
        //     15: {
        //         1: "幼兒教育高級文憑  [自2020年畢業]",
        //     },
        //     10: {
        //         1: [
        //             "幼兒教育高級文憑  [2016至2024年畢業]",
        //             "[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。]",
        //         ],
        //     },
        //     11: {
        //         1: [
        //             "幼兒教育高級文憑  [2019至2024年畢業]",
        //             "[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。]",
        //         ],
        //         2: "幼兒教育(榮譽)學士  [2022至2026年畢業]",
        //     },
        //     12: {
        //         1: "幼兒教育高級文憑  [全日制學生於2017至2022年畢業, 兼讀制學生於2019及2020年畢業]",
        //     },
        //     13: {
        //         1: "幼兒教育高級文憑  [2019至2025年畢業]",
        //         2: "幼兒教育榮譽學士  [2024至2027年畢業]",
        //     },
        //     16: {
        //         1: "幼兒教育高級文憑  [2018至2023年畢業]",
        //         2: "幼兒教育(榮譽)學士學位  [2019至2022年畢業]",
        //     },
        //     17: {
        //         1: "幼兒教育高級文憑  [自2019年畢業]",
        //     },
        //     18: {
        //         1: "幼兒教育高級文憑  [2019至2024年畢業]",
        //     },
        //     19: {
        //         1: "幼兒教育高級文憑 (融合教育)  [2020至2026年畢業]",
        //     },
        // },
        nameEn: "姓名（英文）",
        nameCn: "姓名（中文）",
        documentType: "請選擇證件類型",
        hKid: "身份證號碼",
        passport: "護照號碼",
        dateOfBirth: "出生日期",
        residentialAddress: "住址",
        telNo: "電話",
        dcTelNo: "日間聯絡／手提電話",
        emailAddress: "電郵地址",
        nameOfWorkingCentre: "現職學前機構名稱",
        workingCentreAddress: "幼兒中心地址",
        telNoAddress: "電話",
        awardedByA: "提供課程學院",
        awardedByB: "提供課程學院",
        first: "（A）",
        second: "（B）",
        third: "（C）",
        courseName: "課程名稱",
        othersSpecify: "其他（請說明）",
        nameOfCentre: "學前機構或幼兒中心名稱",
        postHeld: "職位",
        dateOfCommencement: "到職日期",
        dateOfResignation: "已離職",
        dateOfLeaving: "離職日期",
        ageRange: "所服務兒童的年齡組別",
        school: "香港教育學院",
        schoolCourseName: "幼兒教育高級文憑課程",
        ageRangeTips: "例如：“2-3” 為二至三歲",
        popMessage: "本課程同樣適用於CCS和CCW,你想同時申請CCS和CCW嗎?",
        yes: "是",
        no: "否",
        ccwPopMessage:
            "所選課程僅適用於幼兒工作員，你是否確認改為只申請註冊為幼兒工作員？",
        ccsPopMessage:
            "所選課程僅適用於幼兒中心主管，你是否確認改為只申請註冊為幼兒中心主管？",
        ccwMessage:
            "所選課程僅適用於幼兒工作員，請選擇適用於幼兒工作員及幼兒中心主管的課程，或在第2步改為只申請註冊為幼兒工作員。",
        ccsMessage:
            "所選課程僅適用於幼兒中心主管，請選擇適用於幼兒工作員及幼兒中心主管的課程，或在第2步改為只申請註冊為幼兒中心主管。",
    },
    errorMsg: {
        E01: "請輸入正確格式.",
        E02: "請輸入有效值",
        E03: "請至少在身份證號碼和護照號碼之間填一個",
        E04: "請至少在{{fieldOne}}和{{fieldTwo}}之間填一個",
        E0116: "可輸入的最大長度:",
        E0117: "可輸入的最小長度:",
        E05: "請至少輸入一個項目",
        telNo: "請至少在電話和日間聯絡／手提電話之間填一個",
        ageRange:
            "請輸入一個有效的所服務兒童的年齡組別（例如：“2-3” 為二至三歲）",
        na: "不適用",
        E06: "請填寫完整",
        repeatCourse: "請選擇不重複的課程",
        ccsAndccwRequired:
            "如欲同時申請註冊成為幼兒工作員及幼兒中心主管，申請人須完成符合註冊幼兒工作員及幼兒中心主管的相關認可課程。",
    },
};
export default Form041TC;
